module.exports = __webpack_public_path__ + "static/media/partner.766d5d08.png";